'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const HolidayFilters = () => {
  const [packageType, setPackageType] = useState<string[]>([]);
  const [activities, setActivities] = useState<string[]>([]);
  const [accommodation, setAccommodation] = useState<string[]>([]);

  const toggleFilter = (value: string, currentFilters: string[], setFilters: (filters: string[]) => void) => {
    if (currentFilters.includes(value)) {
      setFilters(currentFilters.filter(f => f !== value));
    } else {
      setFilters([...currentFilters, value]);
    }
  };

  const packageTypes = [
    { name: 'Beach & Relaxation', icon: 'SunIcon' },
    { name: 'Adventure & Sports', icon: 'BoltIcon' },
    { name: 'Cultural & Heritage', icon: 'BuildingLibraryIcon' },
    { name: 'Family Friendly', icon: 'UserGroupIcon' },
    { name: 'Romantic Getaway', icon: 'HeartIcon' },
    { name: 'City Break', icon: 'BuildingOffice2Icon' },
  ];

  const activitiesList = [
    'Sightseeing Tours',
    'Water Sports',
    'Hiking & Trekking',
    'Spa & Wellness',
    'Food & Wine',
    'Shopping',
    'Wildlife Safari',
    'Skiing & Snow Sports',
  ];

  const accommodationTypes = [
    '5-Star Hotels',
    '4-Star Hotels',
    'Boutique Hotels',
    'Beach Resorts',
    'All-Inclusive',
    'Villas & Apartments',
  ];

  return (
    <div className="bg-card rounded-lg shadow-brand p-6 space-y-6 sticky top-20">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-lg font-semibold text-foreground">Filters</h3>
        <button className="text-sm text-primary hover:text-secondary transition-colors font-bold">
          Clear all
        </button>
      </div>

      {/* Package Type */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="SparklesIcon" size={18} className="text-muted-foreground" />
          <span>Package Type</span>
        </h4>
        <div className="space-y-2">
          {packageTypes.map((type) => (
            <label key={type.name} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={packageType.includes(type.name)}
                onChange={() => toggleFilter(type.name, packageType, setPackageType)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground group-hover:text-primary transition-colors font-bold">
                {type.name}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Activities */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="BoltIcon" size={18} className="text-muted-foreground" />
          <span>Activities Included</span>
        </h4>
        <div className="space-y-2 max-h-48 overflow-y-auto">
          {activitiesList.map((activity) => (
            <label key={activity} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={activities.includes(activity)}
                onChange={() => toggleFilter(activity, activities, setActivities)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground group-hover:text-primary transition-colors font-bold">
                {activity}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Accommodation */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="HomeIcon" size={18} className="text-muted-foreground" />
          <span>Accommodation</span>
        </h4>
        <div className="space-y-2">
          {accommodationTypes.map((type) => (
            <label key={type} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={accommodation.includes(type)}
                onChange={() => toggleFilter(type, accommodation, setAccommodation)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground group-hover:text-primary transition-colors font-bold">
                {type}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HolidayFilters;